import React, { memo, useCallback } from "react";

import { useHistory, useRouteMatch } from "react-router-dom";

import { Column } from "components/Layout";
import TabRow from "components/TabSelector/TabRow";

import { SecurityTrimmedNavigationTab } from "containers/LivestockSales/SecurityTrimmedNavigationTab";

import { useHasSelectedDesktopView } from "hooks/useScreenSize";

import {
  getLivestockSaleId,
  getSaleyardAuctionRoute,
  getSaleyardName,
} from "lib/navigation";

import { getTemporaryBusinessWarningsAttentionInfoInCurrentSale } from "selectors";

const MobileBobbyCalfSaleTabs = [
  {
    id: "overview",
    display: true,
    title: "Overview",
    component: SecurityTrimmedNavigationTab,
    attentionInfoSelector:
      getTemporaryBusinessWarningsAttentionInfoInCurrentSale,
    hasPermissionSelector: () => true,
  },
  {
    id: "take",
    display: true,
  },
  {
    id: "sell",
    display: true,
  },
];
const DesktopBobbyCalfSaleTabs = [
  {
    id: "overview",
    display: true,
    title: "Overview",
    component: SecurityTrimmedNavigationTab,
    attentionInfoSelector:
      getTemporaryBusinessWarningsAttentionInfoInCurrentSale,
    hasPermissionSelector: () => true,
  },
  {
    id: "take",
    display: true,
  },
  {
    id: "sell",
    display: true,
  },
  {
    id: "eids",
    title: "EIDs",
    display: true,
  },
  {
    id: "nlis",
    title: "NLIS",
    display: true,
  },
];

function BobbyCalfSaleTabsComponent() {
  const isDesktop = useHasSelectedDesktopView();
  const { params } = useRouteMatch();
  const history = useHistory();

  const setSection = useCallback(
    section => {
      history.push(
        `${getSaleyardAuctionRoute(
          getSaleyardName(),
          getLivestockSaleId(),
        )}/${section}`,
      );
    },
    [history],
  );
  const { section } = params;

  const tabs = isDesktop ? DesktopBobbyCalfSaleTabs : MobileBobbyCalfSaleTabs;

  return (
    <Column printHidden>
      <TabRow
        tabs={tabs}
        selectedTab={section}
        setSelectedTab={setSection}
        backgroundColor="gray95"
      />
    </Column>
  );
}

export default memo(BobbyCalfSaleTabsComponent);
